import * as fromDatatype from '../datatype-library/index'

export interface bl_mrp_prodsys_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  prodsys_type: fromDatatype.VarcharDatatypeInterface;
  sequence: fromDatatype.IntegerDatatypeInterface;
  independent_process: boolean;
  external_process: boolean;
  remarks: fromDatatype.TextDatatypeInterface;
};

export class bl_mrp_prodsys_hdr_RowClass implements bl_mrp_prodsys_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  prodsys_type: fromDatatype.VarcharDatatypeInterface;
  sequence: fromDatatype.IntegerDatatypeInterface;
  independent_process: boolean;
  external_process: boolean;
  remarks: fromDatatype.TextDatatypeInterface;
}
